module.exports = __webpack_public_path__ + "img/vampiro.f3cf0ae9.jpg";